import {  ServiceOrderStageEnum } from "../Services/api/service-orders/service-order.interface";

export const labelsOrderProductionStage : Record<ServiceOrderStageEnum, string> = {

    DEAD: 'Erro',
    INITIAL: 'Inicial',
    PROCESSING: 'Em processamento',
    EMITTED_OS: 'OS Emitida',
    PREPRINT: 'Pré-impressão',
    PRINT: 'Impressão',
    CUT_AND_VINCO_AUTO: 'Corte e Vinco Automático',
    CUT_AND_VINCO_MANUAL: 'Corte e Vinco Manual',
    LAMINATION: 'Laminação',
    HIGHLIGHT: 'Destaque',
    FEATURED: 'Destacado',
    WATER_TO_FINISH: 'Aguar. P/Finalizar',
    IN_MACHINE: 'Em máquina',
    PRODUCED: 'Produzido',
    AWAITING_INVOICING: 'Aguardando Faturamento',
    WAITING_BILLING: 'Aguardando Faturamento',
    INVOICE_PROBLEM: 'Com Problemas de Faturamento',
    BILLING_PROBLEM: 'Com Problemas',
    INVOICED: 'Faturado',
    BILLED: 'Faturado'
};

export const normalizeOrderProductionStage = (stage: ServiceOrderStageEnum): { bgColor: string; textColor: string } => {
    const bgColor: Record<ServiceOrderStageEnum, string> = {
        DEAD: 'rgba(244, 67, 54, 0.7)', // Vermelho
        INITIAL: 'rgba(255, 193, 7, 0.7)', // Amarelo
        PROCESSING: 'rgba(33, 150, 243, 0.7)', // Azul
        EMITTED_OS: 'rgba(103, 58, 183, 0.7)', // Roxo
        PREPRINT: 'rgba(255, 87, 34, 0.7)', // Laranja
        PRINT: 'rgba(9, 86, 24, 0.7)', // Verde
        CUT_AND_VINCO_AUTO: 'rgba(121, 85, 72, 0.7)', // Marrom
        CUT_AND_VINCO_MANUAL: 'rgba(158, 158, 158, 0.7)', // Cinza
        LAMINATION: 'rgba(51, 113, 121, 0.7)', // Ciano
        HIGHLIGHT: 'rgba(197, 184, 72, 0.7)', // Amarelo Claro
        FEATURED: 'rgba(156, 39, 176, 0.7)', // Roxo Escuro
        WATER_TO_FINISH: 'rgba(0, 150, 136, 0.7)', // Verde Água
        IN_MACHINE: 'rgba(205, 220, 57, 0.7)', // Verde Lima
        PRODUCED: 'rgba(40, 85, 135, 0.7)', // Azul Escuro
        BILLED: 'rgba(0, 0, 0, 0.7)', // Roxo
        AWAITING_INVOICING: 'rgba(0, 0, 0, 0.7)',
        WAITING_BILLING: 'rgba(0, 0, 0, 0.7)',
        INVOICE_PROBLEM: 'rgba(0, 0, 0, 0.7)',
        BILLING_PROBLEM: 'rgba(0, 0, 0, 0.7)',
        INVOICED: 'rgba(0, 0, 0, 0.7)',
    };

    const textColor: Record<ServiceOrderStageEnum, string> = {
        DEAD: '#FFFFFF',
        INITIAL: '#212121',
        PROCESSING: '#FFFFFF',
        EMITTED_OS: '#FFFFFF',
        PREPRINT: '#FFFFFF',
        PRINT: '#FFFFFF',
        CUT_AND_VINCO_AUTO: '#FFFFFF',
        CUT_AND_VINCO_MANUAL: '#212121',
        LAMINATION: '#FFFFFF',
        HIGHLIGHT: '#212121',
        FEATURED: '#FFFFFF',
        WATER_TO_FINISH: '#FFFFFF',
        IN_MACHINE: '#212121',
        PRODUCED: '#FFFFFF',
        BILLED: '#FFFFFF',
        AWAITING_INVOICING: '#FFFFFF',
        WAITING_BILLING: '#FFFFFF',
        INVOICE_PROBLEM: '#FFFFFF',
        BILLING_PROBLEM: '#FFFFFF',
        INVOICED: '#FFFFFF',
    };

    return {
        bgColor: bgColor[stage] || 'rgba(0,0,0,0.5)',
        textColor: textColor[stage] || '#FFFFFF'
    };
};
